import React, {  Component } from 'react';
import { connect } from 'react-redux';
import { addSplitLineToBookedOrder } from '../../redux/actions';
import moment from 'moment';

class SplitLineOverlayDialog extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showDialog: false,
            errorMessage: '',
            quantity1:'',
            quantity2:''
        }
    }
    closeDialog(event) {
        event.preventDefault();
        this.setState({
            showDialog: false,
            errorMessage: '',
        });
        this.props.handleDialog && this.props.handleDialog('SplitLineOverlayDialog');
    }
	handleContinue(event) {
        event.preventDefault();
        const self = this;
        const { updateBookedOrderDetails } = self.props;
        let {selectedLineItemForSplit, selectedSKUIndex } = self.props;
		const quantity1 = self.state.quantity1;
        const quantity2 = self.state.quantity2;
        const totalQuantity = parseInt(quantity1, 10)+ parseInt(quantity2, 10);
        if(parseInt(selectedLineItemForSplit.quantity, 10) === totalQuantity) {
            selectedLineItemForSplit = {
                ...selectedLineItemForSplit,
                splitLines : [{splitQty: quantity1}, {splitQty: quantity2}],
                quantity : quantity1,
                originalQuantity :quantity1

            }
            updateBookedOrderDetails.items[selectedSKUIndex] = selectedLineItemForSplit;
            updateBookedOrderDetails.isSplitLinePresent = true;
            let payload = {
                orderHeaderId : updateBookedOrderDetails.headerId,
                orderNumber : updateBookedOrderDetails.orderNumber,
                orderLineId : selectedLineItemForSplit.lineId,
                item : selectedLineItemForSplit.item,
                orderedQty : quantity1,
                lineNum : selectedLineItemForSplit.lineNo,
                responsibilityName: 'GEOM Setup User (US Appliances)',
                splitBy : self.props.state.user.userDetails.sso,
                splitQty : quantity2,
                changeReason : 'Customer Request',
                changeComments : 'SPLIT LINE',
                createdDate : moment().format('YYYY-MM-DD'),
                createdBy : updateBookedOrderDetails.createdById,
                lastUpdatedBy : self.props.state.user.userDetails.sso,
                lastUpdatedDate : moment().format('YYYY-MM-DD'),
            }
            self.props.addSplitLineToBookedOrder(payload, response => {
                if(response.status) {
                    this.setState({
                        showDialog: false,
                        errorMessage: '',
                    }, () => {
                        this.props.addSplitLine(updateBookedOrderDetails);
                    });
                }
            });
            
        } else {
            this.setState({
                errorMessage: 'Quantity 1 + Quantity 2 must be equal to Total Original Qty'
            });
        }
	}
    componentDidMount() {
        const self = this;
        self.setState({
            showDialog: self.props.showDialog,
        });
    }
    handleChange(event) {
        let { name, value } = event.target;
        this.setState({
            [name] : value > 0 ? value : '',
        });
	}
    render() {
        const self = this;
         const {selectedLineItemForSplit} = self.props;
        return (
            <div className={"overlayDialog "+(this.state.showDialog ?"visible":"hide")} id="showPriceSourceOverlayDialog">
                <div className="blackoutLayer"></div>
                <div className="overlayDialogWindow">
                    <a className="closeButton" onClick={this.closeDialog.bind(this)}>×</a>
                    <h2 className="title">SPLIT LINE</h2>
                    <p className="bold">Divide the total quantity as needed. If the line is partially reserved, put the reserved quantity in 1. The total must equal the original quantity</p>
                    {this.state.errorMessage && <p className="red bold">{this.state.errorMessage}</p>}
					<table className="formTableTypeA">
                        <thead>
                            <tr>
                                <th><h4>{selectedLineItemForSplit.item}</h4></th>
                                <th style={{textAlign: 'center'}}><h4>{selectedLineItemForSplit.quantity}</h4></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>Quantity 1</td>
                                <td style={{textAlign: 'center'}}>
                                    <input type="text" 
                                    onChange={this.handleChange.bind(this)} 
                                    name="quantity1" value={this.state.quantity1}/>
                                </td>
                            </tr>
                            <tr>
                                <td>Quantity 2</td>
                                <td style={{textAlign: 'center'}}>
                                    <input type="text"
                                    onChange={this.handleChange.bind(this)} 
                                    name="quantity2" value={this.state.quantity2}/>
                                </td>
                            </tr>
                        </tbody>
                    </table> 
                        <div className="noButtonContainer">
                            <a className="noButton blueButton" onClick={this.closeDialog.bind(this)}>CANCEL</a>
                        </div>
                        <div className="yesButtonContainer">
                            <a className="yesButton blueButton" onClick={this.handleContinue.bind(this)} name= "update">SAVE</a>
                        </div> 
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
   return {state};
};

const mapDispatchToProps = (dispatch) => ({
   addSplitLineToBookedOrder : (payload, params, response) => dispatch(addSplitLineToBookedOrder(payload, params, response)),
});

SplitLineOverlayDialog = connect(mapStateToProps, mapDispatchToProps)(SplitLineOverlayDialog);
export default SplitLineOverlayDialog;


// WEBPACK FOOTER //
// ./src/App/components/dialogs/splitLineOverlayDialog.js